/**
 * Arbitrum icon SVG component
 * Standard Arbitrum logo
 */
export function ArbitrumIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="5 5 15 15"
      fill="none"
      className={className}
    >
      <path
        fill="currentColor"
        d="m13.149 13.766l-.75 2.045a.24.24 0 0 0 0 .18l1.286 3.522l1.495-.857l-1.791-4.89a.129.129 0 0 0-.24 0m1.5-3.445a.128.128 0 0 0-.24 0l-.75 2.044a.24.24 0 0 0 0 .18l2.113 5.768l1.491-.857l-2.614-7.14z"
      />
      <path
        fill="currentColor"
        d="M12 5.74q.057 0 .107.03l5.786 3.363a.21.21 0 0 1 .107.185v6.544a.21.21 0 0 1-.107.184l-5.786 3.377a.22.22 0 0 1-.214 0l-5.786-3.37A.21.21 0 0 1 6 15.865V9.318c0-.078.043-.146.107-.185l5.786-3.364A.2.2 0 0 1 12 5.735zm0-.862c-.201 0-.407.055-.587.158L5.73 8.306a1.17 1.17 0 0 0-.587 1.012v6.544c0 .416.223.806.587 1.016l5.683 3.27a1.17 1.17 0 0 0 1.174 0l5.683-3.27a1.16 1.16 0 0 0 .587-1.016V9.318c0-.416-.223-.806-.587-1.012l-5.683-3.27A1.2 1.2 0 0 0 12 4.878"
      />
      <path fill="currentColor" d="m8.242 18.322l.522-1.427l1.05.87l-.98.9z" />
      <path
        fill="currentColor"
        d="M11.525 8.735H10.08a.26.26 0 0 0-.24.175l-3.085 8.542l1.487.87l3.403-9.407a.13.13 0 0 0-.016-.122a.13.13 0 0 0-.109-.058zm2.52 0h-1.44a.26.26 0 0 0-.24.171l-3.532 9.746l1.492.87l3.84-10.61a.13.13 0 0 0-.12-.177"
      />
    </svg>
  );
}
